import React, { useEffect, useState } from "react";
import "./quoteForm.scss";
import Modal from "react-bootstrap/Modal";
import { useWindowSize } from "react-use";
import { quoteForm } from "../../source";
import helper from "../../helpers/helper";
import config from "../../config/config";
import Joi from "joi";
import { parsePhoneNumber, isValidPhoneNumber } from "libphonenumber-js";

const QuoteForm = (props) => {
  const { width } = useWindowSize();

  const [selectedCountryCode, setSelectedCountryCode] = useState("+971");
  const [countryCodes, setCountryCodes] = useState([]);
  const [inputValue, setInputValue] = useState({
    company_name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);

  // Joi validation schema
  const schema = Joi.object({
    company_name: Joi.string().required().messages({
      "string.empty": "Company Name is required",
    }),
    email: Joi.string()
      .required()
      .email({ tlds: { allow: false } })
      .messages({
        "string.empty": "Email is required",
        "string.email": "Please enter a valid email address",
      }),
    phone: Joi.string().required().messages({
      "string.empty": "Phone number is required",
    }),
    message: Joi.string().allow(""),
  });

  const handleClose = () => {
    setInputValue({
      company_name: "",
      email: "",
      phone: "",
      message: "",
    });
    setErrors({});
    setShowThankYou(false);
    setIsSubmitting(false);
    setSelectedCountryCode("+971");
    props.onHide();
  };

  const validateField = (name, value) => {
    const fieldSchema = schema.extract(name);
    const { error } = fieldSchema.validate(value);
    return error ? error.details[0].message : null;
  };

  const validatePhone = (phoneNumber, countryCode) => {
    try {
      const fullNumber = `${countryCode}${phoneNumber}`;
      if (!isValidPhoneNumber(fullNumber)) {
        return "Please enter a valid phone number";
      }
      return null;
    } catch (error) {
      return "Invalid phone number format";
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputValue((prev) => ({ ...prev, [name]: value }));

    const error = validateField(name, value);
    if (name === "phone") {
      const phoneError = validatePhone(value, selectedCountryCode);
      setErrors((prev) => ({ ...prev, [name]: phoneError }));
    } else {
      setErrors((prev) => ({ ...prev, [name]: error }));
    }
  };

  const handleCountryCodeChange = (e) => {
    const newCountryCode = e.target.value;
    setSelectedCountryCode(newCountryCode);

    if (inputValue.phone) {
      const phoneError = validatePhone(inputValue.phone, newCountryCode);
      setErrors((prev) => ({ ...prev, phone: phoneError }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Validate all fields
    const validationErrors = {};
    Object.keys(inputValue).forEach((key) => {
      const error = validateField(key, inputValue[key]);
      if (error) validationErrors[key] = error;
    });

    // Phone validation
    const phoneError = validatePhone(inputValue.phone, selectedCountryCode);
    if (phoneError) validationErrors.phone = phoneError;

    setErrors(validationErrors);

    // If there are validation errors, stop submission
    if (Object.keys(validationErrors).length > 0) {
      setIsSubmitting(false);
      return;
    }

    const formData = {
      ...inputValue,
      phone: `${selectedCountryCode}${inputValue.phone}`, // Combine country code and phone
    };

    const response = await helper.post(`${config.api_url}/leads`, formData);

    if (response.status === 200) {
      setShowThankYou(true);
      setInputValue({
        company_name: "",
        email: "",
        phone: "",
        message: "",
      });
      setIsSubmitting(false);
      setTimeout(() => {
        handleClose();
      }, 5000);
    }
  };

  const fetchCountryCodes = async () => {
    const { data } = await helper.get(
      `${config.api_url}/general/countries/codes`
    );

    if (data) {
      const sortedData = data.sort((a, b) => {
        return parseInt(a.phone_code) - parseInt(b.phone_code);
      });

      setCountryCodes(sortedData);
    }
  };

  useEffect(() => {
    fetchCountryCodes();
  }, []);

  return (
    <>
      <Modal {...props} onHide={handleClose} className="quote_modal_container">
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="form_flex">
            {width > 767 ? (
              <div className="popup_img_wrapper">
                <img
                  src={quoteForm}
                  alt="banner"
                  width={630}
                  height={855}
                  className="popup_banner"
                />
              </div>
            ) : null}
            <div className="form_container">
              <h2 className="section_title48">
                GET A <span>QUOTE</span>
              </h2>
              {/* <p className="section_desc">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Praesent aliquet urna sed metus consectetur, eget aliquam neque
                porta.
              </p> */}
              <form className="form_wrapper" onSubmit={handleSubmit}>
                <div className="input_wrapper">
                  <div className="input_field_wrapper">
                    <input
                      type="text"
                      className="input_field"
                      name="company_name"
                      value={inputValue.company_name}
                      onChange={handleInputChange}
                      //   placeholder="Full Name *"
                    />
                    {inputValue.company_name.length === 0 && (
                      <span className="placeholder">
                        Company Name <span style={{ color: "#E33825" }}>*</span>
                      </span>
                    )}
                  </div>
                  <p className="error_message">{errors.company_name}</p>
                </div>

                <div className="input_wrapper">
                  <div className="input_field_wrapper">
                    <input
                      type="email"
                      className="input_field"
                      name="email"
                      value={inputValue.email}
                      onChange={handleInputChange}
                    />
                    {inputValue.email.length === 0 && (
                      <span className="placeholder">
                        Email ID <span style={{ color: "#E33825" }}>*</span>
                      </span>
                    )}
                  </div>
                  <p className="error_message">{errors.email}</p>
                </div>

                <div className="input_wrapper">
                  <div className="input_field_wrapper select_field_wrapper">
                    <div className="tel_row">
                      <div className="tel_col">
                        <select
                          className="input_field select_field"
                          value={selectedCountryCode}
                          onChange={handleCountryCodeChange}
                        >
                          {countryCodes?.map((code) => (
                            <option value={`+${code.phone_code}`}>
                              +{code.phone_code}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="tel_col">
                        <input
                          type="tel"
                          className="input_field"
                          name="phone"
                          value={inputValue.phone}
                          onChange={handleInputChange}
                        />
                        {inputValue.phone.length === 0 && (
                          <span className="placeholder">
                            Phone <span style={{ color: "#E33825" }}>*</span>
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <p className="error_message">{errors.phone}</p>
                </div>

                <div className="input_wrapper">
                  <div className="input_field_wrapper">
                    <textarea
                      name="message"
                      id="message"
                      className="input_field msg_field"
                      placeholder="Message"
                      value={inputValue.message}
                      onChange={handleInputChange}
                    ></textarea>
                  </div>
                  <p className="error_message">{errors.message}</p>
                </div>

                <div className="btn_wrapper">
                  <button className="submit_btn" disabled={isSubmitting}>
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </button>
                </div>

                {showThankYou && (
                  <div className="thank_msg_wrapper">
                    <p className="section_desc">
                      {" "}
                      Thank you for reaching out! We appreciate your message and
                      will get back to you shortly.
                    </p>
                  </div>
                )}
              </form>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default QuoteForm;
